import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { format, differenceInCalendarDays, endOfMonth, startOfDay, startOfWeek,endOfDay,startOfMonth,endOfWeek} from "date-fns";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'bcac-search-group',
  templateUrl: './search-group.component.html',
  styleUrls: ['./search-group.component.scss']
})
export class SearchGroupComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    private datePipe: DatePipe,
  ) {
    let random=Math.ceil(Math.random()*10000);
    this.bigDiv=random+this.bigDiv;
    this.smallBtn=random+this.smallBtn;
   }
  searchForm: FormGroup;
  ngOnInit() {
    this.initForm();
  }
  initForm(){
    let formData = {}
    for (const iterator of this.searchData) {
      if (iterator.defaultStatus) {
        if (iterator.sectionStatus) {
          formData[iterator.attributeValue[0]] = iterator.defaultValue[0];
          formData[iterator.attributeValue[1]] = iterator.defaultValue[1];
        } else {
          formData[iterator.attributeValue[0]] = iterator.defaultValue[0];
        }
      } else {
        if (iterator.sectionStatus) {
          formData[iterator.attributeValue[0]] = null;
          formData[iterator.attributeValue[1]] = null;
        } else {
          formData[iterator.attributeValue[0]] = null;
        }
      }
    }
    this.searchForm = this.fb.group(formData);
  }
  bigDiv='context';
  smallBtn="btn";
  ngAfterViewInit() {
    this.setHeight();
  }
  ngOnDestroy() {
    if (this.statusJudge) {
      clearTimeout(this.statusJudge);
    }
  }
  statusJudge=null;
  setHeight(){
    if (document.getElementById(this.smallBtn)) {
      document.getElementById(this.smallBtn).style.height = document.getElementById(this.bigDiv).offsetHeight  + 'px';
    }else{
      this.statusJudge=setTimeout(()=>{
        this.setHeight();
      },100)
    }
  }
  span = 6
  searchData = []
  @Output()
  queryDataSubmit = new EventEmitter<any>();
  queryFun() {
    let returnData = {}
    for (const iterator of this.searchData) {
      switch (iterator.type) {
        case "year":
          if (this.searchForm.get(iterator.attributeValue[0]).value) {
            returnData[iterator.attributeValue[0]] = this.datePipe.transform(this.searchForm.get(iterator.attributeValue[0]).value, 'yyyy');
          }else{
            returnData[iterator.attributeValue[0]] = null;
          }
          if (iterator.sectionStatus) {
            if (this.searchForm.get(iterator.attributeValue[1]).value) {
              returnData[iterator.attributeValue[1]] = this.datePipe.transform(this.searchForm.get(iterator.attributeValue[1]).value, 'yyyy');
            }else{
              returnData[iterator.attributeValue[0]] = null;
            }
          }
          break;
        case "date":
          if (iterator.sectionStatus) {
            if (this.searchForm.get(iterator.attributeValue[0]).value) {
              returnData[iterator.attributeValue[0]] = this.datePipe.transform(startOfDay(this.searchForm.get(iterator.attributeValue[0]).value), "yyyy-MM-dd HH:mm:ss");
            }
            if (this.searchForm.get(iterator.attributeValue[1]).value) {
              returnData[iterator.attributeValue[1]] = this.datePipe.transform(endOfDay(this.searchForm.get(iterator.attributeValue[1]).value), "yyyy-MM-dd HH:mm:ss");
            }
          } else {
            if (this.searchForm.get(iterator.attributeValue[0]).value) {
              returnData[iterator.attributeValue[0]] = [this.datePipe.transform(startOfDay(this.searchForm.get(iterator.attributeValue[0]).value), "yyyy-MM-dd HH:mm:ss"), this.datePipe.transform(endOfDay(this.searchForm.get(iterator.attributeValue[0]).value), "yyyy-MM-dd HH:mm:ss")];
            }else{
              returnData[iterator.attributeValue[0]] = null;
            }
          }
          break;
        case "month":
          if (iterator.sectionStatus) {
            if (this.searchForm.get(iterator.attributeValue[0]).value) {
              returnData[iterator.attributeValue[0]] = this.datePipe.transform(startOfMonth(this.searchForm.get(iterator.attributeValue[0]).value), "yyyy-MM-dd HH:mm:ss");
            }else{
              returnData[iterator.attributeValue[0]] = null;
            }
            if (this.searchForm.get(iterator.attributeValue[1]).value) {
              returnData[iterator.attributeValue[1]] = this.datePipe.transform(endOfMonth(this.searchForm.get(iterator.attributeValue[1]).value), "yyyy-MM-dd HH:mm:ss");
            }else{
              returnData[iterator.attributeValue[1]] = null;
            }
          } else {
            if (this.searchForm.get(iterator.attributeValue[0]).value) {
              returnData[iterator.attributeValue[0]] = [this.datePipe.transform(startOfMonth(this.searchForm.get(iterator.attributeValue[0]).value), "yyyy-MM-dd HH:mm:ss"), this.datePipe.transform(endOfMonth(this.searchForm.get(iterator.attributeValue[0]).value), "yyyy-MM-dd HH:mm:ss")];
            }else{
              returnData[iterator.attributeValue[0]] = null;
            }
          }
          break;
        case "datetime":
          if (iterator.sectionStatus) {
            if (this.searchForm.get(iterator.attributeValue[0]).value) {
              returnData[iterator.attributeValue[0]] = this.datePipe.transform(this.searchForm.get(iterator.attributeValue[0]).value, "yyyy-MM-dd HH:mm:ss");
            }else{
              returnData[iterator.attributeValue[0]] = null;
            }
            if (this.searchForm.get(iterator.attributeValue[1]).value) {
              returnData[iterator.attributeValue[1]] = this.datePipe.transform(this.searchForm.get(iterator.attributeValue[1]).value, "yyyy-MM-dd HH:mm:ss");
            }else{
              returnData[iterator.attributeValue[1]] = null;
            }
          } else {
            if (this.searchForm.get(iterator.attributeValue[0]).value) {
              returnData[iterator.attributeValue[0]] = [this.datePipe.transform(this.searchForm.get(iterator.attributeValue[0]).value, "yyyy-MM-dd HH:mm:ss"), this.datePipe.transform(this.searchForm.get(iterator.attributeValue[0]).value, "yyyy-MM-dd HH:mm:ss")];
            }else{
              returnData[iterator.attributeValue[0]] = null;
            }
          }
          break;
        case "week":
          if (iterator.sectionStatus) {
            if (this.searchForm.get(iterator.attributeValue[0]).value) {
              returnData[iterator.attributeValue[0]] = this.datePipe.transform(startOfWeek(this.searchForm.get(iterator.attributeValue[0]).value), "yyyy-MM-dd HH:mm:ss");
            }else{
              returnData[iterator.attributeValue[0]] = null;
            }
            if (this.searchForm.get(iterator.attributeValue[1]).value) {
              returnData[iterator.attributeValue[1]] = this.datePipe.transform(endOfWeek(this.searchForm.get(iterator.attributeValue[1]).value), "yyyy-MM-dd HH:mm:ss");
            }else{
              returnData[iterator.attributeValue[1]] = null;
            }
          } else {
            if (this.searchForm.get(iterator.attributeValue[0]).value) {
              returnData[iterator.attributeValue[0]] = [this.datePipe.transform(startOfWeek(this.searchForm.get(iterator.attributeValue[0]).value), "yyyy-MM-dd HH:mm:ss"), this.datePipe.transform(endOfWeek(this.searchForm.get(iterator.attributeValue[0]).value), "yyyy-MM-dd HH:mm:ss")];
            }else{
              returnData[iterator.attributeValue[0]] = null;
            }
          }
          break;
        case "time":
          if (iterator.sectionStatus) {
            if (this.searchForm.get(iterator.attributeValue[0]).value) {
              returnData[iterator.attributeValue[0]] = this.datePipe.transform(this.searchForm.get(iterator.attributeValue[0]).value, "HH:mm:ss");
            }else{
              returnData[iterator.attributeValue[0]] = null;
            }
            if (this.searchForm.get(iterator.attributeValue[1]).value) {
              returnData[iterator.attributeValue[1]] = this.datePipe.transform(this.searchForm.get(iterator.attributeValue[1]).value, "HH:mm:ss");
            }else{
              returnData[iterator.attributeValue[1]] = null;
            }
          } else {
            if (this.searchForm.get(iterator.attributeValue[0]).value) {
              returnData[iterator.attributeValue[0]] = this.datePipe.transform(this.searchForm.get(iterator.attributeValue[0]).value, "HH:mm:ss");
            }else{
              returnData[iterator.attributeValue[0]] = null;
            }
          }
          break;
        default:
          returnData[iterator.attributeValue[0]] = this.searchForm.get(iterator.attributeValue[0]).value;
          break;
      }

    }
    
    this.queryDataSubmit.emit(returnData)
  }
  intervalDisabled = (current: Date): boolean => {
    return differenceInCalendarDays(current, new Date()) > 0;
  }
  startValue = null
  endValue = null
  openStart(value) {
    this.endValue = value
  }
  openEnd(value) {
    this.startValue = value
  }
  intervalDisabledStart = (current: Date): boolean => {
    if (this.endValue) {
      if (this.searchForm.get(this.endValue).value==null) {
        return false;
      }else{
        return differenceInCalendarDays(current, this.searchForm.get(this.endValue).value) > 0;
      }
    } else {
      return false;
    }
  }
  intervalDisabledEnd = (current: Date): boolean => {
    if (this.startValue) {
      if (this.searchForm.get(this.startValue).value==null) {
        return false;
      }else{
        return differenceInCalendarDays(current, this.searchForm.get(this.startValue).value) < 0;
      }
    } else {
      return false;
    }
  }
  intervalDisabledStartS = (current: Date): boolean => {
    if (this.endValue) {
      if (this.searchForm.get(this.endValue).value==null) {
        let a=differenceInCalendarDays(current, new Date()) > 0
        // console.log(a,"startTime1",this.datePipe.transform(current, "yyyy-MM-dd HH:mm:ss"));
        return a;
      }else{
        let a=(differenceInCalendarDays(current, new Date()) > 0 || differenceInCalendarDays(current, this.searchForm.get(this.endValue).value) > 0)
        // console.log(a,"startTime2",this.datePipe.transform(current, "yyyy-MM-dd HH:mm:ss"));
        return a;
      }
    } else {
      // console.log("没有得到属性",this.endValue);
      return false;
    }
  }
  intervalDisabledEndS = (current: Date): boolean => {
    if (this.startValue) {
      if (this.searchForm.get(this.startValue).value==null) {
        return differenceInCalendarDays(current, new Date()) > 0;
      }else{
        return (differenceInCalendarDays(current, new Date()) > 0 || differenceInCalendarDays(current, this.searchForm.get(this.startValue).value) < 0);
      }
    } else {
      return false;
    }
  }
  @Input()
  set columnWidth(value: string) {
    if (value == 'small') {
      this.span = 6;
    } else if (value == 'large') {
      this.span = 12;
    } else if (value == 'default') {
      this.span = 8;
    }
  }
  @Input()
  set searchDataList(value) {
    this.searchData = value;
    this.initForm();
  }
  // ngOnChanges(){
  //   console.log("改变啦",this.searchData);
  // }
}
